'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dRecipe$002dNutrition from "./mealorama.-Recipe-Nutrition.js";
var $p;
/** @constructor */
function $c_Lmealorama_RecipeNutrition$() {
}
export { $c_Lmealorama_RecipeNutrition$ as $c_Lmealorama_RecipeNutrition$ };
$p = $c_Lmealorama_RecipeNutrition$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_RecipeNutrition$;
/** @constructor */
function $h_Lmealorama_RecipeNutrition$() {
}
export { $h_Lmealorama_RecipeNutrition$ as $h_Lmealorama_RecipeNutrition$ };
$h_Lmealorama_RecipeNutrition$.prototype = $p;
$p.m = (function() {
  return "RecipeNutrition";
});
$p.aSq = (function(x$0) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  return new $j_mealorama$002e$002dRecipe$002dNutrition.$c_Lmealorama_RecipeNutrition($x_1.l, $x_1.h, x$0.g(1), (x$0.g(2) | 0), (x$0.g(3) | 0), x$0.g(4));
});
var $d_Lmealorama_RecipeNutrition$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_RecipeNutrition$, "mealorama.RecipeNutrition$", ({
  GL: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_RecipeNutrition$ as $d_Lmealorama_RecipeNutrition$ };
var $n_Lmealorama_RecipeNutrition$;
function $m_Lmealorama_RecipeNutrition$() {
  if ((!$n_Lmealorama_RecipeNutrition$)) {
    $n_Lmealorama_RecipeNutrition$ = new $c_Lmealorama_RecipeNutrition$();
  }
  return $n_Lmealorama_RecipeNutrition$;
}
export { $m_Lmealorama_RecipeNutrition$ as $m_Lmealorama_RecipeNutrition$ };
//# sourceMappingURL=mealorama.-Recipe-Nutrition$.js.map
